// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"94298170","154":"62ee7cfe","852":"ddcd9aa3"}[chunkId] + ".chunk.css";
};